import { InternalSubmissionDialog } from "@/components/submissions/InternalSubmissionDialog";

export default function SubmitCandidateDialog(props) {
  return <InternalSubmissionDialog {...props} />;
}
